import React from "react";
import { Page } from "../../common/components/Page";
import { LostUnitsList } from "./LostUnitsList";

export const LostUnitsListPage: React.FC = () => {
  return <Page content={LostUnitsList} title="Lost Units" />;
};
